import { APP_CONFIG_ENV_MAP, CURRENT_ENV, IS_PRODUCTION_BUILD } from '@/shared/environments';

export const openOAuthUrlInCurrentTab = (url: string): Promise<void> => {
  window.location.assign(url);
  return Promise.resolve();
};

const ENV_FILE_CONFIG = {
  auth: {
    region: import.meta.env.VITE_REGION,
    userPoolId: import.meta.env.VITE_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_USER_POOL_WEB_ID,
  },
  oauth: {
    clientId: import.meta.env.VITE_CLIENT_ID,
    domain: import.meta.env.VITE_DOMAIN,
  },
  sso: {
    entraid: {
      oauth: {
        clientId: import.meta.env.VITE_SSO_ENTRA_ID,
        domain: import.meta.env.VITE_DOMAIN,
        responseType: 'code',
        scope: ['email', 'openid', 'phone'],
      },
      userPoolWebClientId: import.meta.env.VITE_SSO_ENTRA_ID,
    },
    keyence: {
      oauth: {
        clientId: import.meta.env.VITE_SSO_KEYENCE_ID,
        domain: import.meta.env.VITE_DOMAIN,
        responseType: 'code',
        scope: ['email', 'openid', 'phone'],
      },
      userPoolWebClientId: import.meta.env.VITE_SSO_KEYENCE_ID,
    },
  },
};

const DEFAULT_CONFIG = {
  auth: {
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
  oauth: {
    redirectSignIn: window.location.origin,
    redirectSignOut: `${window.location.origin}/auth`,
    responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
    urlOpener: openOAuthUrlInCurrentTab,
  },
};

const getConfig = () => {
  return IS_PRODUCTION_BUILD || !CURRENT_ENV ? ENV_FILE_CONFIG : APP_CONFIG_ENV_MAP[CURRENT_ENV];
};

export const getAuthConfig = (provider?: string) => {
  const config = getConfig();

  const baseAuth = {
    ...DEFAULT_CONFIG.auth,
    ...config.auth,
  };
  const baseOAuth = {
    ...DEFAULT_CONFIG.oauth,
    ...config.oauth,
  };

  if (provider && config.sso && provider in config.sso) {
    const ssoConfig = config.sso[provider as keyof typeof config.sso];
    return {
      Auth: {
        ...baseAuth,
        userPoolWebClientId: ssoConfig.userPoolWebClientId,
      },
      oauth: {
        ...baseOAuth,
        ...ssoConfig.oauth,
      },
    };
  }

  return {
    Auth: baseAuth,
    oauth: baseOAuth,
  };
};

export const AUTH_CONFIG = getAuthConfig();
